import { render, staticRenderFns } from "./FriendRequestItem.vue?vue&type=template&id=84d7c184"
import script from "./FriendRequestItem.vue?vue&type=script&lang=js"
export * from "./FriendRequestItem.vue?vue&type=script&lang=js"
import style0 from "./FriendRequestItem.vue?vue&type=style&index=0&id=84d7c184&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/lyb/工作/个人/leo——im/新版代码/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports